"use client";
import React, { useEffect, useState } from "react";
import PopularCard from "@packages/shared-components/common-utilities/cards/popular-card/popular-card";
import { v4 as uuidv4 } from "uuid";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Pagination, Navigation } from "swiper/modules";

interface PopularCardSliderProps {
  popularSubjects?: any[];
  institutionTextkey?: any;
  commonGAAttrs?: any;
  institutionId?: any;
  isPostgraduate?: any;
  commonOldGAAttrs?:any
}

const PopularCardSlider = ({
  popularSubjects,
  institutionTextkey,
  commonGAAttrs,
  institutionId,
  isPostgraduate,
  commonOldGAAttrs
}: PopularCardSliderProps) => {
  const [isMobile, setIsMobile] = useState(true);
  const colorSchemes = [
    { bg: "bg-blue-100", leaf: "bg-blue-200", arrow: "fill-primary-500" },
    { bg: "bg-green-100", leaf: "bg-green-200", arrow: "fill-secondary-500" },
    { bg: "bg-orange-100", leaf: "bg-orange-200", arrow: "fill-orange-600" },
    { bg: "bg-grey-200", leaf: "bg-grey-300", arrow: "fill-grey-600" },
  ];

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth < 1024);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  // useEffect(() => {
  //   const fetchPopularSubjects = async () => {
  //     try {
  //       const response = await fetch(`${process.env.NEXT_PUBLIC_BFF_API_DOMAIN}/hewebsites/v1/institution/popular-subjects`, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "x-api-key": process.env.NEXT_PUBLIC_X_API_KEY!,
  //           "x-correlation-id": uuidv4(),
  //           "sitecode": process.env.SITE_CODE || "",
  //         },
  //         body: JSON.stringify({
  //           networkId: "2",
  //           keyProfileId: "79179",
  //           collegeId: "3747",
  //           intakeYear: "2025",
  //           affiliateId: "220703"
  //         }),
  //         cache: 'no-store',
  //       });
  //       const data = await response.json();
  //       setPopularSubjects(data || []);
  //     } catch (error: any) {
  //       console.error("Error fetching popular subjects:", error);
  //     }
  //   };

  //   fetchPopularSubjects();
  // }, []);

  return (
    <>
      <div className="lg:w-[650px] xl:w-[907px]">
        <Swiper
          slidesPerView="auto"
          spaceBetween={8}
          navigation={true}
          pagination={isMobile ? { clickable: true } : false}
          modules={[Pagination, Navigation]}
          className="MultiSwiper popular"
        >
          {popularSubjects?.map((popularSubject: any, index: number) => {
            const colors = colorSchemes[index % 4];
            return (
              <SwiperSlide key={index}>
                <PopularCard
                  subjectTitle={popularSubject?.subjectName}
                  subjectBgColor={colors.bg}
                  leafBgColor={colors.leaf}
                  rightArrowColor={colors.arrow}
                  subjectTextKey={popularSubject?.subjectTextKey}
                  institutionTextkey={institutionTextkey}
                  institutionId={institutionId}
                  keyProfileId={popularSubject?.keyProfileId || undefined}
                  deptTextKey={popularSubject?.deptTextKey}
                  isPostgraduate={isPostgraduate}
                  commonGAAttrs={{
                    ...commonGAAttrs,
                    cpe_parent_subject:
                      popularSubject?.parentSubjectName || "na",
                    cpe_child_subject: popularSubject?.childSubjectName || "na",
                  }}
                  commonOldGAAttrs={{
                    ...commonOldGAAttrs,
                    cpe_parent_subject:
                      popularSubject?.parentSubjectName || "na",
                    cpe_child_subject: popularSubject?.childSubjectName || "na",
                  }}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </>
  );
};

export default PopularCardSlider;
